
import React,  { Component } from 'react';
import './Contact.css';

class Contact extends Component {
    openMapTab() {
        const url = 'https://map.baidu.com/search/%E7%8E%AF%E7%90%83%E4%B8%AD%E5%BF%83/@11584865.173059078,3555731.5036522998,17.76z?querytype=s&da_src=shareurl&wd=%E7%8E%AF%E7%90%83%E4%B8%AD%E5%BF%83&c=75&src=0&wd2=%E6%88%90%E9%83%BD%E5%B8%82%E6%AD%A6%E4%BE%AF%E5%8C%BA&pn=0&sug=1&l=15&b=(11581881.803147191,3554134.8407202875;11589315.443092195,3558213.0181901148)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2'
        window.open(url);
    }
    render() {
        return (
            <div className="contact">
                <div className='contact-wrap'>
                    <div className='contact-ercode'>
                        <div className='contact-ercode-icon'></div>
                        <p>扫码咨询</p>
                    </div>
                    <div className="contact-phone">
                        <p className='contact-phone-number'>
                            <span className='contact-phone-number-icon'></span>
                            <span className='contact-phone-number-value'>18566295265</span>
                        </p>
                        <p className='contact-address'>中国四川省成都市武侯区益州大道北段1779号</p>
                    </div>
                    <div className="contact-address-map" onClick={this.openMapTab}>
                    </div>
                </div>

            </div>
        );
    }
}

export default Contact;
